//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
import AppContainer from 'app_components/layouts/app'
import BreadcrumbComponent from 'app_components/commons/breadcrumb'
import DataTableComponent from 'app_components/commons/dataTable'
import RoleForm from 'app_components/modules/admin/secure/roleForm'
import RoleSkeleton from './roleSkeleton'
//@end

// @import hooks
// @end

// @INFO Import types
import { IPagination } from 'app_types/pagination/paginationTypes'
import { IRoleListItem } from 'app_types/admin/role/roleTypes'
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../roleScreen.scss'

// @ADD Component types
interface IRoleScreenLayoutProps {
  itemList: IRoleListItem[]
  status: null | 'loading' | 'error'
  add: boolean
  edit: boolean
  view: boolean
  editData: any
  selectedRow: null | string
  pagination: IPagination
  addItem: any
  updateItem: any
  showAddForm: (add: boolean) => void
  showEditForm: (edit: boolean, editData?: any) => void
  onViewerRow: (view: boolean, editData?: any) => void
  onPageChange: (page: number) => void
  onRowClick: (row: any) => void
  removeItem: (userId: string) => void
  onSearch: (search: string) => void
}

const RoleScreenLayout: React.FC<IRoleScreenLayoutProps> = (props) => {

  const { t } = useTranslation()

  return(
    <AppContainer>
      <div className='container-fluid'>
        <BreadcrumbComponent links={['#']} texts={[`${t('components.breadcrumb.roles')}`]} />

        <div className='role-screen'>

          {props.status === 'loading' && (
            <RoleSkeleton />
          )}

          {props.status !== 'loading' && !props.add && !props.edit && !props.view && (
            <>
              <h2>{t('screens.roles.title')}</h2>

              <DataTableComponent
                data={props.itemList}
                headerKeys={[
                  `${t('components.dataTable.headers.name')}`,
                  `${t('components.dataTable.headers.description')}`,
                ]}
                keys={['name', 'description']}
                selectedRow={props.selectedRow}
                pagination={props.pagination}
                detailsKey={[
                  { name: `${t('components.dataTable.details.permissions')}`, key: 'app_module_permissions.description' },
                ]}
                onSearch={props.onSearch}
                onAddRow={props.showAddForm}
                onClickRow={props.onRowClick}
                onRemoveRow={props.removeItem}
                onPageChange={props.onPageChange}
                onEditRow={props.showEditForm}
                onViewerRow={props.onViewerRow}
                onModal={null}
              />
            </>
          )}

          {props.add && (
            <div className="role-container-form col-6 mb-3">
              <div className="d-flex align-items-center mb-2">
                <h2 className="form-title">
                  {t("screens.roles.add_layout.title_page")}
                </h2>
                <button className="btn btn-light btn-sm border ml-2" onClick={() => props.showAddForm(false)}>
                  {t("buttons.back")}
                </button>
              </div>
              <RoleForm
                onHandleSubmit={props.addItem}
                viewer={false}
              />
            </div>
          )}

          {(props.edit || props.view) && props.editData && (
            <div className="role-container-form col-6 mb-3">
              <div className="d-flex align-items-center mb-2">
                {props.edit && (
                  <>
                    <h2 className="form-title">
                      {t("screens.roles.edit_layout.title_page", {role: `${props.editData?.name}`})}
                    </h2>
                    <button className="btn btn-light btn-sm border ml-2" onClick={() => props.showEditForm(false)}>
                      {t("buttons.back")}
                    </button>
                  </>
                )}
                {props.view && (
                  <>
                    <h2 className="form-title">
                      {t("screens.roles.view_layout.title_page")}
                    </h2>
                    <button className="btn btn-light btn-sm border ml-2" onClick={() => props.onViewerRow(false)}>
                      {t("buttons.back")}
                    </button>
                  </>
                )}
              </div>
              <RoleForm
                editData={props.editData}
                onHandleSubmit={props.updateItem}
                viewer={props.view}
              />
            </div>
          )}
        </div>
      </div>
    </AppContainer>
  )
}

export default RoleScreenLayout
